import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SEOLayout } from '../SEOLayout';
import { Button } from '../ui/button';
import { packHtml, packLd, packName, relatedLinks, VERIFIED_LINE, CALCULATOR, CTA_HREF } from '../../data/contentPackRender';

export const PackArticle = ({ page }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const html = useMemo(() => packHtml(page), [page]);
  const section = page.kind === 'airlines' ? ['Airlines', '/airlines'] : ['Destinations', '/destinations'];

  return (
    <SEOLayout title={page.title} description={page.description} breadcrumbs={[{ label: section[0], href: section[1] }, { label: packName(page) }]}>
      <Helmet>
        {packLd(page).map((ld) => <script key={ld['@type']} type="application/ld+json">{JSON.stringify(ld)}</script>)}
      </Helmet>
      <article data-testid="pack-article" className="pack-article">
        <h1>{page.h1}</h1>
        <p data-testid="pack-verified" className="pack-verified">{VERIFIED_LINE}</p>
        <div dangerouslySetInnerHTML={{ __html: html.top }} />
        <div data-testid="pack-cta" className="pack-cta">
          <Button data-testid="pack-cta-btn" onClick={() => navigate(CTA_HREF)}
            className="bg-[#0066CC] hover:bg-[#0052A3] text-white rounded-full h-12 px-6 text-base font-semibold">
            {t('hero.cta_button')}
          </Button>
          <Link to={CALCULATOR} data-testid="pack-calculator-link" className="text-sm text-blue-700 font-medium">Free IATA crate size calculator</Link>
        </div>
        <div dangerouslySetInnerHTML={{ __html: html.bottom }} />
        <nav data-testid="pack-related" className="pack-related" aria-label="Related">
          <h2>Related</h2>
          <ul>{relatedLinks(page).map((l) => <li key={l.href}><Link to={l.href}>{l.label}</Link></li>)}</ul>
        </nav>
      </article>
    </SEOLayout>
  );
};

export default PackArticle;
